
import { User, UserRole, Store, StaffRole } from '../types';
import { storage } from '../lib/storage';

const AUTH_KEY = 'lynqar_auth_user';

export const authService = {
  async signIn(email: string, password: string): Promise<{ user: User | null; error: any }> {
    await new Promise(resolve => setTimeout(resolve, 800));

    if (password !== '123456') {
      return { user: null, error: { message: 'Invalid credentials. Use 123456 for demo.' } };
    }

    const allStores = storage.getStores();
    let role: UserRole = UserRole.CUSTOMER;
    let storeId: string | undefined;
    let staffRole: StaffRole | undefined;

    if (email === 'admin@lynqar.com') {
      role = UserRole.SUPER_ADMIN;
    } else if (email.endsWith('@lynqar.com')) {
      role = UserRole.ADMIN;
      storeId = 'lynqar-gadgets-001';
    } else {
      // Check if user is an owner
      const sellerStore = allStores.find(s => s.ownerId === email);
      if (sellerStore) {
        role = UserRole.SELLER;
        storeId = sellerStore.id;
      } else {
        // Check if user is a staff member across all stores
        for (const s of allStores) {
          const foundStaff = s.staff?.find(staff => staff.email === email);
          if (foundStaff) {
            role = UserRole.STAFF;
            storeId = s.id;
            staffRole = foundStaff.role;
            break;
          }
        }
      }
    }

    const user: User = {
      id: 'u-' + Math.random().toString(36).substr(2, 9),
      email,
      role,
      storeId,
      staffRole
    };

    localStorage.setItem(AUTH_KEY, JSON.stringify(user));
    window.dispatchEvent(new Event('auth-change'));
    return { user, error: null };
  },

  async registerSeller(data: { email: string; storeName: string }): Promise<{ user: User; store: Store }> {
    await new Promise(resolve => setTimeout(resolve, 1200));

    const storeId = 'store-' + Math.random().toString(36).substr(2, 9);
    const newStore: Store = {
      id: storeId,
      name: data.storeName,
      slug: data.storeName.toLowerCase().replace(/\s+/g, '-'),
      status: 'PENDING', // Every new store starts as PENDING
      ownerId: data.email,
      createdAt: new Date().toISOString(),
      staff: []
    };

    storage.saveStoreConfig(newStore);

    const user: User = {
      id: 'u-' + Math.random().toString(36).substr(2, 9),
      email: data.email,
      role: UserRole.SELLER,
      storeId: storeId
    };

    localStorage.setItem(AUTH_KEY, JSON.stringify(user));
    window.dispatchEvent(new Event('auth-change'));
    
    return { user, store: newStore };
  },

  async signOut(): Promise<void> {
    localStorage.removeItem(AUTH_KEY);
    window.dispatchEvent(new Event('auth-change'));
  },

  async getCurrentUser(): Promise<User | null> {
    const data = localStorage.getItem(AUTH_KEY);
    return data ? JSON.parse(data) : null;
  },

  onAuthStateChange(callback: (user: User | null) => void) {
    const handler = async () => {
      const user = await this.getCurrentUser();
      callback(user);
    };

    window.addEventListener('auth-change', handler);
    handler();

    return {
      data: {
        subscription: {
          unsubscribe: () => window.removeEventListener('auth-change', handler)
        }
      }
    };
  }
};
